import { cva } from 'class-variance-authority'

export const cardStyles = cva(
  `
    rounded-3xl
    bg-card
    text-neutral-600
    my-4
    relative
  `,
  {
    variants: {
      color: {
        level0_no_border: 'bg-neutral-0',
        level0: 'bg-neutral-0 border border-neutral-200',
        level1: 'bg-neutral-25',
        level2: 'bg-neutral-100',
        priority: 'bg-orange-0',
        emphasis: 'bg-moss-0',
        brand: 'bg-moss-300 text-neutral-0',
        success: 'bg-green-0',
        warning: 'bg-yellow-0',
        danger: 'bg-red-0',
        green: 'bg-moss-50',
        blueGradient: 'bg-gradient-blue',
        yellowGradient: 'bg-gradient-yellow',
        greenGradient: 'bg-gradient-green',
      },
    },
    defaultVariants: {
      color: 'level0',
    },
  }
)

export const iconStyles = cva(
  `
    h-4
    w-4
    cursor-pointer
    absolute
    top-4
    right-4
  `
)
